import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

export const DashboardResourceStyled = styled(Button)(() => ({
  backgroundColor: 'var(--color-element)',
  borderRadius: '16px',
  height: '260px',
  width: '215px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  padding: 0,
  flexShrink: 0,
}));

export const ResourceImageContainer = styled(Box)(() => ({
  borderTopLeftRadius: '16px',
  borderTopRightRadius: '16px',
  height: '160px',
  width: '100%',
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const ResourceImage = styled('img')(() => ({
  width: '100%',
  height: '100%',
  objectPosition: 'center',
}));
